import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl + '/frtradeprono'
export default {
    list(params) {
        return request({
            url: BASE_URL + '/list',
            method: 'get',
            params
        })
    },
    //查询
    info(param) {
        return request({
            url: BASE_URL + '/info/' + param,
            method: 'get'
        })
    },
    //添加
    add(data) {
        return request({
            url: BASE_URL + '/save',
            method: 'post',
            data
        })
    },

    //编辑
    update(data) {
        return request({
            url: BASE_URL + '/update',
            method: 'post',
            data
        })
    },

    //删除
    delete(data) {
        return request({
            url: BASE_URL + '/delete',
            method: 'post',
            data
        })
    },
}